import Vue from "vue";

export const leadImportsService = {
  list,
  upload
};

function list() {
  return Vue.axios.get("v1/lead_imports");
}

function upload(file) {
  const formData = new FormData();
  formData.set("file", file);

  return Vue.axios.post("v1/lead_imports/csv", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
